enum ESeasonYears {
  SEASON_2425 = '2024/25',
}

export { ESeasonYears }
